import { createVNode as o, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ReplaceFilled.js";
import p from "../components/PfIcon.js";
const e = (r, l) => {
  const t = {
    ...r,
    ...l.attrs
  };
  return o(p, a(t, {
    icon: i
  }), null);
};
e.displayName = "ReplaceFilled";
e.inheritAttrs = !1;
export {
  e as default
};
